// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"449bb35b","455":"10a0ab77"}[chunkId] + ".chunk.js";
};